import { type HTMLAttributes } from "react";
import { LazyComponent } from "../../../utils/LazyComponent";

export interface HeadingNodeProps extends HTMLAttributes<HTMLHeadingElement> {
  level?: number;
  component?: "h1" | "h2" | "h3" | "h4" | "span";
}

export const HeadingNode = (props: HeadingNodeProps) => {
  return <LazyComponent<HeadingNodeProps> name="HeadingNode" {...props} />;
};
